export default __webpack_public_path__ + "static/media/plumb.054ffd74.png";